import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function FadeInSection({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 24
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-1169">
      {children}
    </motion.div>;
}
export function TermsPage() {
  return <div className="bg-charcoal min-h-screen" data-id="element-1170">
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-1171">
        <div className="max-w-3xl mx-auto" data-id="element-1172">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1173">
            <h1 className="text-3xl sm:text-4xl font-bold text-cream mb-3" data-id="element-1174">
              Términos de Uso
            </h1>
            <p className="text-sm text-[#7a7672] mb-12" data-id="element-1175">
              Última actualización: enero 2025
            </p>
          </motion.div>

          <div className="space-y-10" data-id="element-1176">
            <FadeInSection data-id="element-1177">
              <div data-id="element-1178">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-1179">
                  1. Aceptación de los términos
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-1180">
                  Al acceder y utilizar el sitio web de Reclutas Digitales,
                  usted acepta estar sujeto a estos Términos de Uso. Si no está
                  de acuerdo con alguna parte de estos términos, no debe
                  utilizar nuestros servicios.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.05} data-id="element-1181">
              <div data-id="element-1182">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-1183">
                  2. Descripción del servicio
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-1184">
                  Reclutas Digitales es una incubadora de sistemas para agentes
                  y agencias de seguros hispanas en EE.UU. No somos una agencia
                  de seguros, un proveedor de leads ni una institución educativa
                  acreditada.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.1} data-id="element-1185">
              <div data-id="element-1186">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-1187">
                  3. Uso permitido
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm mb-3" data-id="element-1188">
                  Está prohibido:
                </p>
                <ul className="space-y-2 text-sm text-[#b8b4ae]" data-id="element-1189">
                  <li className="flex items-start gap-2" data-id="element-1190">
                    <span className="text-red-400 mt-0.5" data-id="element-1191">×</span> Reproducir o
                    distribuir contenido sin autorización escrita
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1192">
                    <span className="text-red-400 mt-0.5" data-id="element-1193">×</span> Utilizar el
                    sitio para actividades ilegales o fraudulentas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1194">
                    <span className="text-red-400 mt-0.5" data-id="element-1195">×</span> Intentar
                    acceder a sistemas o datos no autorizados
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1196">
                    <span className="text-red-400 mt-0.5" data-id="element-1197">×</span> Interferir
                    con el funcionamiento normal del sitio
                  </li>
                </ul>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.15} data-id="element-1198">
              <div data-id="element-1199">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-1200">
                  4. Propiedad intelectual
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-1201">
                  Todo el contenido del sitio web es propiedad de Reclutas
                  Digitales o sus licenciantes y está protegido por las leyes de
                  propiedad intelectual aplicables.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.2} data-id="element-1202">
              <div data-id="element-1203">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-1204">
                  5. Limitación de responsabilidad
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-1205">
                  En la máxima medida permitida por la ley, Reclutas Digitales
                  no será responsable por daños indirectos, incidentales,
                  especiales o consecuentes que resulten del uso de nuestros
                  servicios.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.25} data-id="element-1206">
              <div data-id="element-1207">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-1208">
                  6. Sin garantía de resultados
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-1209">
                  Reclutas Digitales no garantiza ningún resultado específico,
                  incluyendo ingresos, número de leads, tasas de conversión o
                  crecimiento del negocio.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.3} data-id="element-1210">
              <div data-id="element-1211">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-1212">
                  7. Ley aplicable
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-1213">
                  Estos términos se rigen por las leyes del estado de Florida,
                  EE.UU.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.35} data-id="element-1214">
              <div data-id="element-1215">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-1216">
                  8. Contacto
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-1217">
                  Para preguntas sobre estos términos, contáctenos a través del
                  formulario disponible en nuestro sitio web.
                </p>
              </div>
            </FadeInSection>
          </div>
        </div>
      </section>
    </div>;
}